import { convertLocalizedNumberStringToFloat } from "@core/utils";
import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "@generation/form/src/Validations/AbstractValidation";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";
import { translate } from "../Locales/translator";

export class HasMinimalAmountValidation extends AbstractValidation {
  key = "hasMinimalAmount";

  constructor(public readonly minimalAmount: number, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (!value) {
      return true;
    }
    const valueToCheck = convertLocalizedNumberStringToFloat(value as unknown as string) || 0;
    return valueToCheck >= this.minimalAmount;
  };

  defaultMessage = (label: string): string =>
    translate("Generation_Form_{label}GetalMoetMinimaal{amount}Zijn", {
      label: label,
      amount: this.minimalAmount.toString()
    });
}
